/**
 * Toggle Visibility of the side menu
 *
 * @module app/components/MarketMenuAdapter
 */
import jQuery from 'jquery';

/**
 * Checks if market menu is open
 *
 * @param {Object} wrapper
 *
 * @returns {Boolean}
 *
 * @private
 */
/*jshint -W079 */
let status = function status(wrapper) {

    return (wrapper.attr('data-market-menu') === 'open');
};

/**
 * Handles behavior when the menu is opened
 *
 * @param {Object} wrapper
 *
 * @returns {void}
 *
 * @private
 */
var expand = function expand(wrapper) {

    wrapper.attr('data-market-menu', 'open');
};

/**
 * Handles behavior when the menu is closed
 *
 * @param {Object} wrapper
 *
 * @returns {void}
 *
 * @private
 */
var collapse = function collapse(wrapper) {

    wrapper.attr('data-market-menu', '');
};

/**
 * Delegates an action to execute based on current state
 *
 * @param {Object} wrapper
 *
 * @returns {void}
 *
 * @private
 */
var toggle = function toggle(wrapper) {

    if (status(wrapper)) {
        collapse(wrapper);
    } else {
        expand(wrapper);
    }
};

/**
 * Public functions.
 *
 * @type {Object}
 */
var api = {

    /**
     * Sets up behaviours for the slideout menu
     *
     * @return {void}
     *
     * @public
     */
    init: function init() {

        var canvas = jQuery('#main');

        /**
         * Toggles data-market-menu
         *
         * @returns {void}
         *
         * @private
         */
        var toggleDataMarketMenu = function () {

            toggle(canvas);
            return false;
        };

        canvas.off('click.toggleMarketMenu')
            .on('click.toggleMarketMenu', '#contentarea .bt-off-canvas', toggleDataMarketMenu);
    },
};

export default api;
